<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button
      type="button"
      class="matrix_pageOptionAttributeButton"
      :class="activeClass()"
      @click="
        setPageOption({
          value: value,
          layout: true,
          optionType: 'main',
          ppcode: ppcode,
          option: code
        })
      "
    >
      <div :class="getClassName + 'InnerContainer'">
        <div :class="getClassName + 'Image'">
          <img v-if="imageSrc" :src="imageSrc" />
          <span v-if="!imageSrc">
            {{ $t("Image placeholder") }}
          </span>
        </div>
        <div :class="getClassName + 'Name'">
          {{ name }}
        </div>
      </div>
      <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
    </button>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useTooltipsStore } from "@/stores/modules/tooltips";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useTooltipsStore, ["getShowTooltipsInPOV"]),
    ...mapState(useWebproductStore, ["getActiveProductOptionsSelection"]),
    name: function () {
      return this.propsData.label;
    },
    value: function () {
      return this.propsData.value;
    },
    imageSrc: function () {
      if (this.propsData.image) {
        return this.propsData.image;
      }
      return null;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOV && this.propsData.tooltip;
    }
  },
  methods: {
    ...mapActions(useChangeOptionsStore, ["setPageOption"]),
    activeClass: function () {
      var selectedItems = this.getActiveProductOptionsSelection(this.ppcode);
      return selectedItems.includes(this.value) ? "active" : "";
    }
  },
  props: ["propsData", "ppcode", "code"]
};
</script>
